import { render, staticRenderFns } from "./ListTalksPage.vue?vue&type=template&id=29510d96&scoped=true&"
import script from "./ListTalksPage.vue?vue&type=script&lang=js&"
export * from "./ListTalksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29510d96",
  null
  
)

export default component.exports